/* ============================================================
UNIVERSAL MDIH PDF FILE NAMING
Used across all modules for consistent report naming
============================================================ */

const buildMDIHPdfName = (startupName,moduleName)=>{

const safeName =

(startupName || "Startup")

.toString()

.replace(/[^a-zA-Z0-9 ]/g,"")

.replace(/\s+/g,"_")

.trim();

const safeModule =

(moduleName || "Report")

.replace(/[^a-zA-Z0-9 ]/g,"")

.replace(/\s+/g,"_");

const year = new Date().getFullYear();

return `MDIH_${safeName}_${safeModule}_Report_${year}.pdf`;

};

/* SUPPORT BOTH IMPORT STYLES */

export default buildMDIHPdfName;

export { buildMDIHPdfName };